/**
 * Header parallax effect script
 *
 * @package DZ Theme Framework
 * @license MIT
 */
class DZ_Header {
    constructor() {
        this.ui = {
            body: $(document.body),
            image: $('.site-header-image')
        };

        this.pos = {
            width: this.ui.body.outerWidth(),
            height: this.ui.body.outerWidth(),
            x: 0,
            y: 0
        };

        if(this.ui.image.length && this.pos.width > 1024) {
            this.initEvents();
        }
    }

    initEvents() {
        let self = this;

        this.ui.body.on('mousemove', function(e) {
            self.pos.x = e.clientX;
            self.pos.y = e.clientY;
            self.calculateImagePos();
        });
    }

    calculateImagePos() {
        let max = 80;
        let x = -((this.pos.x / this.pos.width) * max) + 20;
        let y = -((this.pos.y / this.pos.height) * max) + 20;

        this.ui.image.css('-webkit-transform', 'translateX(' + x + 'px) translateY(' + y + 'px)');
        this.ui.image.css('-moz-transform', 'translateX(' + x + 'px) translateY(' + y + 'px)');
        this.ui.image.css('transform', 'translateX(' + x + 'px) translateY(' + y + 'px)');
    }
}
